import React from 'react';
import About from '../About/About';
import Banner from '../Banner/Banner';
import Contact from '../Contact/Contact';
import Experience from '../Experience/Experience';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Projects from '../Projects/Projects';
import {useState,useEffect} from 'react';
import ClipLoader from "react-spinners/ClipLoader";


const Home = () => {
//     const [loading,setLoading] = useState(false);
//     useEffect(()=>{
//     setLoading(true);
//     setTimeout(()=>{
//     setLoading(false)
//     console.log(loading)
    

//     },5000)
//   })
    return (
        <div>
            <Header></Header>
            <Banner></Banner>
            <About></About>
            <Projects></Projects>
            <Experience></Experience>
            <Contact></Contact>
            <Footer></Footer>
            
        </div>
    );
};

export default Home;